module.exports = __webpack_public_path__ + "media/images/phone-eec85b75361048f7ff7d629d734b23f8.png";